import {defineMessages} from 'react-intl';

export default defineMessages({
	loadMore: {
		id: 'paginatedContent.loadMore',
		defaultMessage: 'Load More',
	},
});
